import { Action, createReducer, on } from '@ngrx/store';
import {
  authenticateLocationAction,
  authenticateLocationErrorAction,
  authenticateLocationSuccessAction,
  clearLocationAction,
} from './location.actions';
import { LocationState } from './location.state';

const initialState = new LocationState();

const reducer = createReducer(
  initialState,
  on(authenticateLocationAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(authenticateLocationSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.locationName = payload.locationResponse.name;
    newState.locationGuid = payload.locationGuid;
    return newState;
  }),
  on(authenticateLocationErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failures;
    return newState;
  }),
  on(clearLocationAction, (state) => {
    const newState = { ...state };
    newState.locationName = null;
    return newState;
  })
);

export function locationReducer(state: LocationState | null, action: Action) {
  return reducer(state, action);
}
